import oRequest from '@/libsV2/request.js';

const URL = {
    NOTI_INDEX_NOTIFY: 'notification/Index/getNotify', // 我的消息
    NOTI_INDEX_CHANGE: 'notification/index/change',//已读消息
    COMM_QRCODE_GET: 'comm/qrcode/get',//获取小程序路径
    PROJECT_LOG: 'project/report/projectlog',//获取项目日志
    REPORT_LOG_SHARE: 'report/log/share',//记录信息
    STATIS_CREATELOG: '/statistics/Jiaofustatistics/createlog',//记录日志
    REPORT_SHARE_USER:'/member/share/getid',//内部用户分享id获取
    BIND_PROJECT:'/member/share/bind',//绑定分享关系
    USER_CONTRACT:'member/index/checkcontract',//验证用户和合同的关系

}
export const userContract = (data = {}) => {
    return oRequest.getData(URL.USER_CONTRACT, data);
}
export const bindProject = (data = {}) => {
    return oRequest.getData(URL.BIND_PROJECT, data);
}
export const getNotify = (data = {}) => {
    return oRequest.getData(URL.NOTI_INDEX_NOTIFY, data);
}
export const getChange = (data = {}) => {
    return oRequest.getData(URL.NOTI_INDEX_CHANGE, data);
}
export const getQrcodeUrl = (data = {}) => {
    return oRequest.getData(URL.COMM_QRCODE_GET, data);
}

export const getProjectLog = (data = {}) => {
    return oRequest.getData(URL.PROJECT_LOG, data);
}

export const getReportShare = (data = {}) => {
    return oRequest.getData(URL.REPORT_LOG_SHARE, data);
}
export const getReportShareUser = (data = {}) => {
    return oRequest.getData(URL.REPORT_SHARE_USER, data);
}

export const getCreatelog = (data = {}) => {
    return oRequest.getData(URL.STATIS_CREATELOG, data);
}



